/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SeasonPassStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    ARCHIVED: 'ARCHIVED'
} as const;
export type SeasonPassStatus = typeof SeasonPassStatus[keyof typeof SeasonPassStatus];


export function instanceOfSeasonPassStatus(value: any): boolean {
    for (const key in SeasonPassStatus) {
        if (Object.prototype.hasOwnProperty.call(SeasonPassStatus, key)) {
            if (SeasonPassStatus[key as keyof typeof SeasonPassStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SeasonPassStatusFromJSON(json: any): SeasonPassStatus {
    return SeasonPassStatusFromJSONTyped(json, false);
}

export function SeasonPassStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonPassStatus {
    return json as SeasonPassStatus;
}

export function SeasonPassStatusToJSON(value?: SeasonPassStatus | null): any {
    return value as any;
}

export function SeasonPassStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SeasonPassStatus {
    return value as SeasonPassStatus;
}

